<app-side-modal
  #sideModal
  (goBack)="onCloseWithdrawal.next(true)"
  (hideModal)="onCloseWithdrawal.next(true)"
>
  <div id="cash" class="order-container">
    <div *ngIf="!showMessageContractStatus">
      <div
        class="retiros scrollable-div"
        [class.scrolling-set]="scrolledSet"
        [ngStyle]="{ 'max-height': scrollableHeight }"
      >
        <div class="">
          <div *ngIf="hasBankAccount === false">
            <div class="no-withdrawal-account radio-container">
              <div class="message__header">
                <img alt="card" src="/images/atm-icn-card.svg" />
              </div>
              <div class="message__body">
                Para realizar retiros necesitas tener una cuenta bancaria
                registrada. Da de alta una cuenta bancaria o conoce el estatus
                del registro en la sección
                <button
                  (click)="goToBankAccountRegistration()"
                  type="button"
                  class="button button--link button--semibold button--link-hover"
                >
                  cuenta bancaria</button
                >.
              </div>
            </div>
          </div>

          <div *ngIf="hasBankAccount">
            <h1 class="withdrawal__title">Retiro</h1>
            <div class="availability">
              <div class="availability__amount">
                <img
                  alt="Icon wallet"
                  src="/images/icons/atm-icon-solid-wallet.svg"
                />
                <span>Disponible:</span>
                <strong data-recording-sensitive>{{
                  this.isServiceInterrupted
                    ? '- -'
                    : (withdrawalAmount | hbCustomFormat: '$0,0.00')
                }}</strong>
              </div>
              <button
                class="availability__open-detail"
                [class.availability__open-detail--opened]="isBalanceVisible"
                (click)="toggleBalanceVisibility()"
              >
                <img
                  src="/images/icons/atm-icn-open-arrow.svg"
                  alt="open arrow"
                />
              </button>
            </div>
            <div
              class="availability-detail"
              [class.availability-detail--hidden]="!isBalanceVisible"
            >
              <div class="availability-detail__balance">
                <ng-container *ngFor="let item of cashList">
                  <div class="row">
                    {{ item.title }}
                    <span data-recording-sensitive>{{
                      item.cash
                        | hbCustomFormat
                          : (item.cash < 1 ? '$0,0.00[0]' : '$0,0.00')
                    }}</span>
                  </div>
                </ng-container>
              </div>
              <div class="availability-detail__description">
                <div class="availability-detail__description-title">
                  ¿Cómo funciona?<span
                    >El disponible para retirar dependerá de:</span
                  >
                </div>
                <ul>
                  <li>Si tienes operaciones pendientes</li>
                  <li>
                    La fecha de liquidación de tus instrumentos
                    <span
                      >Por ejemplo, si el lunes vendes un instrumento que
                      liquida en 48 horas, tendrás el dinero disponible para
                      retirar el miércoles</span
                    >
                  </li>
                  <li>
                    Reglas de permanencia
                    <span *ngIf="!showPermanenceMessageV2"
                      >Por regulación, si es tu primer depósito deberás esperar
                      7 días hábiles para poderlo retirar o si es un déposito
                      subsecuente deberás esperar 24 horas.</span
                    >
                    <span *ngIf="showPermanenceMessageV2"
                      >Para realizar el retiro debes esperar a que tu último
                      depósito cumpla 24 hrs. en tu estrategia o si lo deseas
                      comunícate al área Relación con el inversionista: CDMX 55
                      5480 5846 / INT. 800 426 4663</span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="separator"></div>
            <div class="withdrawal__form">
              <div class="row">
                <div class="input input--read-only input--fluid">
                  <label class="input__label">{{ originAccountLabel }}</label>
                  <input
                    class="input__input input__input--prefilled"
                    required
                    disabled
                    [(ngModel)]="originAccountName || currentContractID"
                  />
                </div>
              </div>
              <div class="row" *ngIf="!clearCombo">
                <div
                  class="input input--fluid"
                  [class.input--read-only]="onlyOneAccount"
                >
                  <label class="input__label">Cuenta destino</label>
                  <div
                    class="input__input input__input--prefilled default-bank"
                    *ngIf="onlyOneAccount && defaultAccount"
                  >
                    <div
                      class="bank-container"
                      [innerHTML]="defaultAccount.name"
                      data-recording-sensitive
                    ></div>
                  </div>
                  <combo-select
                    *ngIf="!onlyOneAccount"
                    class="combo-shadow"
                    [placeholder]="'Elegir cuenta'"
                    [isHTML]="true"
                    [resultsList]="accountList"
                    [title]="'Cuenta destino'"
                    (emitSelectedItem)="setWithdrawalAccount($event)"
                    data-recording-sensitive
                  ></combo-select>
                </div>
              </div>

              <div class="outof-service" *ngIf="!isSelectedAccountValid">
                <span class="icon icon-help-blue"></span>
                <span class="text">
                  <strong>En proceso de verificación</strong><br /><br />
                  La verificación podría tomar hasta 7 días hábiles, después de
                  este proceso podrás realizar retiros.
                </span>
              </div>

              <div class="row row--no-margin-bottom">
                <div
                  class="input input--fluid"
                  [class.input--error]="invalidAmount"
                >
                  <hb-input-money
                    label="Monto a retirar"
                    [value]="resetPrice"
                    (valueChange)="setPrice($event)"
                    placeholder="$0.00"
                    prefix="$"
                    [isError]="invalidAmount"
                  >
                    <ng-container *ngIf="invalidAmount">
                      El monto que quieres retirar es mayor al disponible
                    </ng-container>
                  </hb-input-money>
                </div>
              </div>

              <div class="row">
                <div class="input input--fluid">
                  <label class="input__label">Concepto</label>
                  <input
                    class="input__input"
                    type="text"
                    maxlength="18"
                    autocomplete="off"
                    name="concepto"
                    (keypress)="onlyTextNumber($event, $event.target.value)"
                    (keyup)="assignValueConcept($event)"
                  />
                  <span class="input__counter">{{ concepto.length }}/18</span>
                  <span class="input__message">(Opcional)</span>
                </div>
              </div>

              <div class="row">
                <div class="input input--fluid">
                  <label class="input__label">Referencia numérica</label>
                  <input
                    class="input__input"
                    type="text"
                    maxlength="7"
                    autocomplete="off"
                    name="concepto"
                    (keypress)="onlyNumberKey($event, $event.target.value)"
                    (keyup)="assignValueReference($event)"
                  />
                  <span class="input__counter">{{ referencia.length }}/7</span>
                  <span class="input__message">(Opcional)</span>
                </div>
              </div>
            </div>
          </div>

          <button
            *ngIf="canDisplayWithdrawalButton"
            (click)="tryWithdrawalAmount()"
            type="button"
            class="button__withdrawal button button--small button--dark"
            [class.button--disabled]="!isFormValid"
            [disabled]="!isFormValid"
          >
            Retirar
          </button>
        </div>
      </div>
      <div class="radio-container" *ngIf="showMessageContractStatus">
        <span class="icon-atm-icn-info"></span>
        <div class="message__header">Tu contrato aún no esta activo.</div>
        <div class="message__body">
          Para poder realizar operaciones y movimientos de efectivo es necesario
          activarlo.
        </div>
        <div class="radio-container" *ngIf="showMessageContractStatus">
          <span class="icon-atm-icn-info"></span>
          <div class="message__header">Tu contrato aún no esta activo.</div>
          <div class="message__body">
            Para poder realizar operaciones y movimientos de efectivo es
            necesario activarlo.
          </div>
          <div class="message__header">¿Necesitas Ayuda?</div>
          <div class="message__body">homebroker@gbm.com.mx</div>
          <div class="message__body">INT. 01 800 426 4663</div>
          <div class="message__body">CDMX. 55 5480 5846</div>
        </div>
      </div>

      <div class="modal" *ngIf="showConfirmation && !showSPEIConfirmation">
        <div class="mask" *ngIf="!showSPEIConfirmation"></div>
        <div class="limitada container">
          <div class="row title retiro">Confirma tu retiro</div>
          <div class="row">
            <div class="left">Nombre del banco</div>
            <div class="right" data-recording-sensitive>
              {{ order.bankName }}
            </div>
          </div>

          <div class="row">
            <div class="left">Cuenta destino</div>
            <div class="right" data-recording-sensitive>
              {{ order.userBank }}
            </div>
          </div>

          <div class="row">
            <div class="left">Monto a retirar</div>
            <div class="right" data-recording-sensitive>
              {{ withdrawal | hbCustomFormat: '$0,0.00' }} MXN
            </div>
          </div>

          <div
            class="row mfa-message banxico-text top-too"
            *ngIf="mfaType === 0 && needsToken && isOperative"
          >
            Por disposición de Banxico, es necesario que ingreses el código que
            enviamos a tu teléfono celular
          </div>

          <div
            class="row mfa-message banxico-text top-too"
            *ngIf="mfaType === 1 && needsToken && isOperative"
          >
            Por disposición de Banxico, es necesario que ingreses el código que
            genero tu app de autenticación para realizar tu retiro
          </div>

          <div
            class="row mfa-message banxico-text top-too"
            *ngIf="mfaType === 2 && needsToken && isOperative"
          >
            Por seguridad enviamos un código a tu correo. Por favor ingrésalo
            para realizar el retiro.
          </div>

          <div
            class="row token-request simple-input"
            *ngIf="isOperative && needsToken"
          >
            <input
              type="text"
              class="token"
              [class.invalid]="tokenIsInvalid"
              NumberOnly
              required
              matInput
              maxlength="6"
              [(ngModel)]="token"
              (ngModelChange)="changeSecondToken($event, true)"
              autocomplete="off"
              (keyup.enter)="doPreWithdrawalSPEIConfirmation()"
              data-recording-ignore="mask"
            />
            <label>Código</label>
          </div>

          <div class="actions">
            <button
              (click)="cancelConfirmation()"
              [disabled]="lockCancel"
              [class.disabled]="lockCancel"
              class="btn-cancel"
            >
              Cancelar
            </button>
            <button
              (click)="doMovement()"
              [class.disabled]="lockConfirmation"
              class="btn-movement"
            >
              Realizar retiro
            </button>
          </div>
        </div>
      </div>

      <div class="modal" *ngIf="showSPEIConfirmation">
        <div class="mask"></div>
        <div class="limitada container">
          <div class="row title">Retiro</div>

          <div
            class="row mfa-message banxico-text"
            *ngIf="challengeMessageType === 0"
          >
            Por disposición de Banxico, es necesario que ingreses el código que
            enviamos a tu teléfono celular
          </div>

          <div
            class="row mfa-message banxico-text"
            *ngIf="challengeMessageType === 1"
          >
            Por disposición de Banxico, es necesario que ingreses el código que
            genero tu app de autenticación para realizar tu retiro
          </div>

          <div
            class="row mfa-message banxico-text"
            *ngIf="challengeMessageType === 2"
          >
            Por seguridad enviamos un código a tu correo. Por favor ingrésalo
            para realizar el retiro.
          </div>

          <div class="row help-message spei">
            <div class="left">
              <div class="info-icon icon-help-blue"></div>
            </div>
            <div class="right">
              Asegúrate que este código no sea el mismo que ingresaste en la
              ventana anterior
            </div>
          </div>
          <div class="row token-request simple-input">
            <input
              type="text"
              class="token"
              [class.invalid]="tokenIsInvalid"
              NumberOnly
              required
              matInput
              maxlength="6"
              [(ngModel)]="tokenSPEI"
              (ngModelChange)="changeSecondToken($event)"
              autocomplete="off"
              (keyup.enter)="doPreWithdrawalSPEIConfirmation()"
              data-recording-ignore="mask"
            />
            <label>Código</label>
          </div>

          <div class="actions">
            <button
              (click)="cancelSPEIConfirmation()"
              [disabled]="lockCancel"
              [class.disabled]="lockCancel"
              class="btn-cancel"
            >
              Cancelar
            </button>
            <button
              (click)="doPreWithdrawalSPEIConfirmation()"
              [class.disabled]="lockSecondConfirmation"
              class="btn-movement"
            >
              Realizar retiro
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-modal>
